import { DateTime } from 'luxon';
import React from 'react';
import { PortCollection } from 'types/Port';

type Props = {
  portCollection: PortCollection;
};

export const shouldDisplayToolbar = (
  smartPerDiemMinDate: string | undefined | null,
  startDate: string | undefined | null
) => {
  if (!smartPerDiemMinDate || !startDate) {
    return false;
  }
  const smartPerDiemDateLuxon = DateTime.fromISO(smartPerDiemMinDate);
  const startDateLuxon = DateTime.fromISO(startDate);
  if (smartPerDiemDateLuxon > startDateLuxon) {
    return true;
  }
  return false;
};

export const TableToolbar: React.FC<Props> = ({ portCollection }) => {
  const smartPerDiemDateLuxon = DateTime.fromISO(portCollection?.smartPerDiemMinDate || '');
  return (
    <div
      className="bg-orange-50 px-4 w-screen flex space-x-1 h-8 items-center shadow-sm text-black"
      style={{ position: 'absolute', top: '3rem', zIndex: 10 }}
    >
      Smart Per Diem is only available after{' '}
      {smartPerDiemDateLuxon.toLocaleString(DateTime.DATE_FULL)} for {portCollection?.name}
    </div>
  );
};
